import {
  apiUrl,
  getList,
  deleteRecord,
  getSingleRecord,
  saveRecord,
  getAll,
  exportData,
  getStatsData,
} from './apiUtils';
import type { ApiListParamsWithUnderscores, ApiExportParams } from '../types/api/listParams';
import type { ListApiResponse } from '../types/apiResponse';
import type { Stats } from '../types/stats';
import type { TerritoryListItemDto, TerritoryItemDto } from '../types/api';

const baseUrl = apiUrl + '/territories/';

export function getTerritories(
  params?: ApiListParamsWithUnderscores
): Promise<ListApiResponse<TerritoryListItemDto>> {
  return getList(`${baseUrl}search`, params);
}

export function getTerritoryById(id: string): Promise<TerritoryItemDto> {
  return getSingleRecord(baseUrl, id);
}

export function saveTerritory(territory: Partial<TerritoryItemDto>): Promise<{ id: string }> {
  return saveRecord(baseUrl, territory);
}

export function deleteTerritory(id: string): Promise<{ id: string }> {
  return deleteRecord(baseUrl, id);
}

export function getAllTerritories(): Promise<TerritoryListItemDto[]> {
  return getAll(baseUrl);
}

export function getDisallowedSkus(
  id: string,
  params?: ApiListParamsWithUnderscores
): Promise<ListApiResponse<unknown>> {
  return getList(`${baseUrl}${id}/disallowedskus`, params);
}

export function getAllowedSkus(
  id: string,
  params?: ApiListParamsWithUnderscores
): Promise<ListApiResponse<unknown>> {
  return getList(`${baseUrl}${id}/allowedskus`, params);
}

export function exportTerritoryData(params: ApiExportParams): Promise<void> {
  return exportData(`${apiUrl}/export/territories/search`, 'name', params);
}

export function getStats(id: string): Promise<Stats> {
  return getStatsData(baseUrl, id);
}
